module.exports = __webpack_public_path__ + "static/img/Illustration_5_OPS.9d2993d1.svg";